import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FinancialItemImportFileContainerModel } from '../../../../../../models/aggregates/erp/financial/financial-item-file-import-container.model';
import { ApiVisa } from '../../shared/api-visa.model';
@Injectable({ providedIn: 'root' })
export class FinancialItemImportFileService extends BaseApiTemplateService<FinancialItemImportFileContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-hdr';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-hdr';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, fileType: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/' + fileType;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  uploadImportFileToCreateEcomsyncItems(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-to-marketplace/backoffice-ep/upload';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-to-marketplace/backoffice-ep/upload';
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

}
